module.exports = "<div *ngIf=\"state=='loading'\">Loading ...</div>\r\n<div *ngIf=\"note\">\r\n<h1>{{note.title}}</h1>\r\n<app-tag-list [tags]=\"note.tags\"></app-tag-list><br>\r\n<div [innerHTML]=\"note.text\"></div>\r\n</div>\r\n<a [routerLink]=\"['/notes/list']\" class=\"my-2 btn btn-secondary\"><i class=\"fas fa-angle-left\"></i> Back</a>\r\n<a [routerLink]=\"['/notes/edit', note._id]\" class=\"my-2 btn btn-secondary\" *ngIf=\"note\"><i class=\"fas fa-edit\"></i> Edit</a>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/notes/view-note/view-note.component.html
// module id = ./src/app/notes/view-note/view-note.component.html
// module chunks = main